/**
 * Campaign banner section: disclaimer overlay and carousel nav button states.
 *
 * Sections are found via .campaign-banners[data-section-id].
 * Disclaimer triggers use [data-disclaimer-trigger] with data-disclaimer-text.
 */
(function () {
  var MOBILE_MQ = '(max-width: 767.98px)';

  function isMobile() {
    return window.matchMedia(MOBILE_MQ).matches;
  }

  function init(sectionEl) {
    if (!sectionEl || !sectionEl.dataset.sectionId) return;

    initDisclaimers(sectionEl);
    initCarousel(sectionEl);
  }

  /* ── Disclaimer handling (overlay on all viewports) ── */
  function initDisclaimers(sectionEl) {
    var overlay = sectionEl.querySelector('.campaign-banners__disclaimer-overlay');
    if (!overlay) return;

    function positionOverlay(bannerEl, text) {
      if (!text) return;
      overlay.textContent = text;
      overlay.classList.add('is-visible');
      overlay.removeAttribute('hidden');
      overlay.setAttribute('aria-hidden', 'false');
      var rect = bannerEl.getBoundingClientRect();
      var s = overlay.style;
      s.top = (rect.bottom + 4) + 'px';
      s.left = rect.left + 'px';
      s.width = Math.max(rect.width, 100) + 'px';
      s.minWidth = '100px';
    }

    function hideOverlay() {
      overlay.classList.remove('is-visible');
      overlay.setAttribute('hidden', '');
      overlay.setAttribute('aria-hidden', 'true');
      overlay.textContent = '';
    }

    /* Mobile: tap icon to show overlay, tap elsewhere to close */
    sectionEl.addEventListener('click', function (e) {
      if (!isMobile()) return;

      var trigger = e.target.closest('[data-disclaimer-trigger]');
      if (trigger) {
        e.preventDefault();
        e.stopPropagation();
        var bannerEl = trigger.closest('.campaign-banner');
        var text = trigger.dataset.disclaimerText || '';
        if (!bannerEl || !text) return;
        hideOverlay();
        positionOverlay(bannerEl, text);
        return;
      }

      /* Tap outside the overlay or icon → close */
      if (!overlay.contains(e.target)) {
        hideOverlay();
      }
    });

    /* Desktop: hover/focus icon to show overlay */
    sectionEl.querySelectorAll('.campaign-banner-group').forEach(function (group) {
      var icon = group.querySelector('[data-disclaimer-trigger]');
      var bannerEl = group.querySelector('.campaign-banner');
      var disclaimerText = icon ? (icon.dataset.disclaimerText || '') : '';

      if (!disclaimerText || !icon) return;

      function showDesktop() {
        if (isMobile()) return;
        if (bannerEl) positionOverlay(bannerEl, disclaimerText);
      }

      function hideDesktop() {
        if (isMobile()) return;
        hideOverlay();
      }

      icon.addEventListener('mouseenter', showDesktop);
      icon.addEventListener('focus', showDesktop);

      group.addEventListener('mouseleave', function (e) {
        if (e.relatedTarget && overlay.contains(e.relatedTarget)) return;
        if (e.relatedTarget && icon.contains(e.relatedTarget)) return;
        hideDesktop();
      });

      icon.addEventListener('mouseleave', function (e) {
        if (e.relatedTarget && overlay.contains(e.relatedTarget)) return;
        hideDesktop();
      });

      group.addEventListener('focusout', function (e) {
        if (group.contains(e.relatedTarget)) return;
        hideDesktop();
      });
    });

    overlay.addEventListener('mouseenter', function () {
      var activeGroup = sectionEl.querySelector('.campaign-banner-group:hover');
      if (activeGroup) {
        var icon = activeGroup.querySelector('[data-disclaimer-trigger]');
        var b = activeGroup.querySelector('.campaign-banner');
        var text = icon ? (icon.dataset.disclaimerText || '') : '';
        if (b && text) positionOverlay(b, text);
      }
    });
    overlay.addEventListener('mouseleave', hideOverlay);
  }

  /* ── Carousel: nav button states ── */
  function initCarousel(sectionEl) {
    var carousel = sectionEl.querySelector('.campaign-banners__carousel');
    if (!carousel) return;

    var slider = carousel.querySelector('.slider');
    var prevBtn = carousel.querySelector('button[name="prev"]');
    var nextBtn = carousel.querySelector('button[name="next"]');

    function updateNavStates() {
      if (!slider || !prevBtn || !nextBtn) return;
      var maxScroll = slider.scrollWidth - slider.clientWidth;
      if (maxScroll <= 1) {
        prevBtn.disabled = true;
        nextBtn.disabled = true;
        return;
      }
      var left = Math.round(slider.scrollLeft);
      prevBtn.disabled = left <= 0;
      nextBtn.disabled = left >= maxScroll - 1;
    }

    /* Update nav states after carousel loads */
    function onLoaded() {
      updateNavStates();
    }

    if (carousel.hasAttribute('loaded')) {
      onLoaded();
    } else {
      new MutationObserver(function (_, obs) {
        if (carousel.hasAttribute('loaded')) {
          obs.disconnect();
          onLoaded();
        }
      }).observe(carousel, { attributes: true, attributeFilter: ['loaded'] });
    }

    /* Delayed check for initial layout */
    setTimeout(function () {
      requestAnimationFrame(updateNavStates);
    }, 400);

    window.addEventListener('on:debounced-resize', updateNavStates);

    /* Scroll-based nav state updates */
    if (slider) {
      var scrollTimer;
      slider.addEventListener('scroll', function () {
        clearTimeout(scrollTimer);
        scrollTimer = setTimeout(updateNavStates, 150);
      });
    }
  }

  /* ── Bootstrap ── */
  function run() {
    document.querySelectorAll('.campaign-banners[data-section-id]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  /* Theme editor: re-init on section load */
  document.addEventListener('shopify:section:load', function (e) {
    if (!e.detail || !e.detail.sectionId) return;
    var wrapper = document.getElementById('shopify-section-' + e.detail.sectionId);
    if (wrapper) {
      var el = wrapper.querySelector('.campaign-banners[data-section-id]');
      if (el) init(el);
    }
  });
})();
